import { useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";
import { useLoading } from "../../context/loadingContext";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const api = async (datos) => {
  const { data } = await clienteAxios.get(
    `/sucursalVirtual/crm/provision/dispositivosConectados?cont_id=${datos.cont_id}`
  );
  return data;
};

const useListarDispos = () => {
  const { setLoading, removeLoading } = useLoading();
  return useMutation(api, {
    onMutate: () => {
      setLoading({
        id: "cambioRed",
        message: "Por favor espere...",
      });
    },
    onSuccess: (response) => {
      removeLoading({ id: "cambioRed" });
    },
    onError: (error) => {
      removeLoading({ id: "cambioRed" });

      toast.error("Error al listar los dispositivos");
    },
  });
};

export default useListarDispos;
